module.exports = __webpack_public_path__ + "img/ease-of-use.12eb40e0.svg";